import angular from "angular";

angular
	.module('app')
	.component('dfIndexPage', {
		template: require('./df-index-page.html'),
        controller: ['$http', controller],
        bindings: {
		    cars: '<',
        }
    });
    
function controller($http) {
 
	let $ctrl = this;

	$ctrl.selectedCar = null;

	$ctrl.$onInit = function () {
    };

	$ctrl.selectCar = function (index) {
		$ctrl.selectedCar = index;
	}

	$ctrl.unSelectCar = function () {
		$ctrl.selectedCar = null;
	}
}